import { SideBarRenderer } from "@faire/deprecated-retailer-visitor-shared/views/settings/profile/SideBarRenderer";
import { useMenuItems } from "@faire/deprecated-retailer-visitor-shared/views/settings/useMenuItems";
import { Dropdown } from "@faire/web/slate/Dropdown";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import omit from "lodash/omit";
import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

export const SideBar: React.FC<{ className: string; selected: string }> = ({
  selected,
  className,
}) => {
  const { isTabletAndBelow } = useViewport();
  const { push } = useHistory();

  const menuItems = useMenuItems();

  return (
    <section className={className}>
      {isTabletAndBelow ? (
        <div style={{ height: "42px" }}>
          <Dropdown
            data-test-id="account_settings_dropdown"
            value={selected}
            options={menuItems.map((item) => omit(item, "path"))}
            onDropdownOpen={() => {
              menuItems.forEach((menuItem) => {
                menuItem.handleOnVisible?.();
              });
            }}
            onSelect={({ value }) => {
              const selectedMenuItem = menuItems.find(
                (item) => item.value === value
              );
              const path = selectedMenuItem?.path;
              selectedMenuItem?.handleClick?.();

              if (path) {
                push(path);
              }
            }}
          />
        </div>
      ) : (
        <Menu>
          <SideBarRenderer menuItems={menuItems} selected={selected} />
        </Menu>
      )}
    </section>
  );
};

const Menu = styled.section`
  flex: 1 1 0%;
`;
